import { Dispatch, SetStateAction } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useFormMutation } from 'mutations/useFormMutation';
import { SellerVtex } from 'pages/logistica/sellers-vetex/types';

export function useMutateSellerVtexStatus({ setOpen }: { setOpen: Dispatch<SetStateAction<SellerVtex | null>> }) {
    const { mutateAsync, isLoading } = useFormMutation();
    const queryClient = useQueryClient();

    const mutateSellersVtex = ({ fgAtivo, dsObservacao, idSeller }: { fgAtivo: boolean; dsObservacao?: string; idSeller: string }) => {
        return mutateAsync(
            {
                url: `/gestao/seller/updatestatus/${idSeller}`,
                method: 'PUT',
                formData: {
                    fgAtivo,
                    dsObservacao,
                },
            },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries({ queryKey: ['sellers-vtex'] });
                    setOpen(null);
                },
            },
        );
    };

    return { mutateSellersVtex, isLoading };
}
